import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/config";

const navLinks = [
  { label: "Services", to: "/services" },
  { label: "Our Work", to: "/our-work" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative bg-[#070d1f] border-t border-[#2C374D]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 items-start">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3">
              <img
                src={BUSINESS.logoUrl}
                alt="Conan Sharman Plumbing logo"
                className="h-14 w-14 object-contain bg-white rounded-md p-1"
              />
              <div className="leading-tight">
                <p className="font-display text-xl md:text-2xl text-white tracking-wide">
                  CONAN SHARMAN
                </p>
                <p className="text-[10px] uppercase tracking-[0.22em] text-[#D47A4A]">
                  Plumbing &amp; Drain Cleaning Ltd
                </p>
              </div>
            </Link>
            <p className="mt-5 text-[#A0ABC0] text-sm max-w-md">
              {BUSINESS.tagline}. Honest, qualified plumbing trade serving
              Edinburgh since 2011.
            </p>
          </div>

          {/* Sitemap */}
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-5">
              Explore
            </p>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-[#F8F9FA] hover:text-[#D47A4A] transition-colors uppercase tracking-[0.18em] text-xs"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:justify-self-end w-full md:w-auto">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-5">
              Contact
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={BUSINESS.phoneHref}
                  className="flex items-center gap-3 text-[#F8F9FA] hover:text-[#D47A4A] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4 text-[#D47A4A]" />
                  {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={BUSINESS.emailHref}
                  className="flex items-center gap-3 text-[#F8F9FA] hover:text-[#D47A4A] transition-colors break-all"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 text-[#D47A4A]" />
                  {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#A0ABC0]">
                <MapPin className="w-4 h-4 text-[#D47A4A]" />
                Edinburgh, Scotland
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#2C374D] flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs uppercase tracking-[0.22em] text-[#A0ABC0]">
            © {year} {BUSINESS.name}. All rights reserved.
          </p>
          <p className="text-xs uppercase tracking-[0.22em] text-[#A0ABC0]">
            Built for Edinburgh · Honest Trade
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
